export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-[800px] mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-14">
          <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
            <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl bg-background-950/30 backdrop-blur flex items-center justify-center">
              <i className="ri-smartphone-line text-4xl md:text-5xl text-background-50"></i>
            </div>
          </div>

          <div className="text-center md:text-left flex-1">
            <span className="text-xs font-label text-primary-400 bg-primary-500/15 px-3 py-1 rounded-full">移动端体验</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mt-3">
              随时随地在线吃瓜
            </h2>
            <p className="text-sm text-background-400 mt-3 leading-relaxed">
              吃瓜视频在线观看已全面适配移动端浏览器，无需下载APP，打开手机浏览器即可畅享全部吃瓜内容。无论你是在通勤路上、午休时间还是睡前刷手机，都能随时随地满足在线吃瓜需求。
            </p>
            <p className="text-xs text-background-500 mt-4">
              适配 iOS Safari · Android Chrome · 微信内置浏览器
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}